<section *ngIf="!isOpened">
  <div class="row justify-content-between row-buttons align-center mb-2">
    <div class="col-12 col-sm-12">
      <div class="container-style d-grid gap-2 d-flex justify-content-end">
        <app-custom-button [title]="'Revertir Importación'" [label]="'Revertir Importación'" [severity]="'danger'"
          [width]="'10rem'" [icon]="'pi pi-undo'" (onClick)="reverseRentalBalance()"></app-custom-button>
        <app-custom-modal #reverseRentalBalanceModal [label]="'Revertir Importación de Saldos Alquiler'"
          [disabled]="!permissionUpdatable" [header]="'Revertir Importación de Saldos Alquiler'"
          [children]="componentRegisterReverseRentalBalance" [width]="'30vw'" hidden></app-custom-modal>
      </div>
    </div>
  </div>
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formImport">
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 fw-bold">
              <label>Para realizar el proceso de importación del detalle de la entrada, descargue la guía y siga los
                pasos:</label>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-autocomplete formControlName="companyId" [labelText]="'Companía'" [list]="listCompanies"
                [required]="true" [recovery]="true" (onChangeSelect)="getCompany($event)">
              </app-custom-autocomplete>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event)">
              </app-custom-select>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-6 col-6">
              <app-custom-datepicker formControlName="dateBalances" [labelText]="'Fecha'"
                [required]="true"></app-custom-datepicker>
            </div>
            <div class="col-lg-5 col-md-10 col-sm-12 col-12 d-flex align-items-end mt-2 mt-md-0 gap-2">
              <app-custom-button [title]="'Seleccionar Archivo'" [label]="'Seleccionar Archivo'" [severity]="'success'"
                [width]="'10rem'" [icon]="'pi pi-upload'" (onClick)="attach()"
                [disabled]="!permissionUpdatable"></app-custom-button>
              <input id="fileImport" type="file" type="file" (change)="getNameFile($event)" hidden>
              <p class="m-0">{{nameFile}}</p>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex align-items-end justify-content-between gap-2 mt-2">
              <app-custom-button [label]="'Descargar Guía Import.'" [severity]="'success'" [width]="'10rem'"
                [disabled]="!permissionUpdatable" (onClick)="downloadGuideImport()"></app-custom-button>
              <app-custom-button [label]="'Importar'" [severity]="'primary'" [disabled]="!permissionUpdatable"
                [variant]="undefined" (onClick)="importBalance()" [width]="'5rem'"></app-custom-button>
            </div>
          </div>
          <div class="row">
            <div id="list" *ngIf="visibleTxt">
              <h6>Lista de Errores y Alertas</h6>
              <p>Total errores: {{rentalBalanceAlerts.length}}</p>
              <div id="container-alerts" *ngFor="let rentalBalanceAlert of rentalBalanceAlerts">
                <p [ngClass]="errorRentalBalance == 1 ? 'message-error' : 'message-alert'">
                  {{rentalBalanceAlert.message}}
                </p>
              </div>
            </div>
            <div class="row" *ngIf="visibleTxt">
              <div class="d-flex justify-content-end">
                <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [icon]="'pi pi-file-export'"
                  [width]="'5.5rem'" (onClick)="downloadErrorsTxt()"></app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>